import { inject, observer, Provider } from "mobx-react";
import React from "react";
import { NavigateFunction } from "react-router-dom";
import { Button, Confirm, Dropdown, Grid, Input } from "semantic-ui-react";
import withNavigation from "../../../hocs/withNavigation";
import { AgGridReact } from "@ag-grid-community/react/lib/agGridReact";
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';
import { AgGridText } from '../../../core/agGridText';
import OpenItem from "../../../components/OpenItem";
import { RootStore } from "../../../stores/RootStore";
import { toJS } from "mobx";
import { ManufacturerStore } from "./ManufacturerStore";
import DeleteButton from "../../../components/DeleteButton";


interface IStores {
    ManufacturerStore: ManufacturerStore
}

interface IManufacturerPageProps {
    navigate?: NavigateFunction;
    RootStore?:RootStore
}

class ManufacturerPage extends React.Component<IManufacturerPageProps> {
    private stores: IStores

    constructor(props: any){
        super(props);

        this.stores = { ManufacturerStore: new ManufacturerStore(this.props.RootStore)}
    }

    componentDidMount(): void {
        this.stores.ManufacturerStore.getManufacturers()
    }

    public render() {
        const { ManufacturerStore } = this.stores
        return <div>
            <Provider {...this.stores}>
            <div style={{ margin: 20, width: '95%' }}>
                        <Confirm open={ManufacturerStore.isItemOpen}	      
                            style={{width: 600}}                      
                            closeOnEscape={false} //disables closing the window by pressing ESC	
                            closeOnDimmerClick={false} //disables closing the window by clicking outside of it	                            
                            onCancel={() => {ManufacturerStore.setItemOpenFalse();}}	
                            cancelButton="Mégse"
                            onConfirm={() => {ManufacturerStore.saveManufacturer();}}
                            confirmButton="Mentés"
                            content={
                                <div style={{ padding: 30 }}>
                                    <div style={{marginRight: '20px'}}>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{width: '33%'}}>
                                                <div style={{marginBottom: 5}}>
                                                    <label>Megnevezés</label>
                                                </div>
                                                <Input value={ManufacturerStore.temporaryName}
                                                onChange={(event, data) => { ManufacturerStore.updateManufacturerItem(data.value) }}/>
                                            </div>   
                                            <div style={{width: '33%', marginLeft: 30}}>
                                                <div style={{marginBottom: 5}}>
                                                    <label>Aktív</label>
                                                </div>                                                
                                                <Dropdown
                                                    selection
                                                    fluid
                                                    placeholder='Kérem, válasszon...'
                                                    options={ManufacturerStore.yesNoDatasource}												
                                                    value={+ManufacturerStore.temporaryIsActive}
                                                    onChange={(event, data) => { ManufacturerStore.updateManufacturerItemIsActive(+data.value) }}
											    />
                                            </div>                                            
                                        </div>                                        
                                    </div>                                                                                                            
                                </div>
                            }
                        />
						<Grid>                            
							<Grid.Row centered>
                                <Grid.Column width={5}>                                    
                                    <Grid>                    
                                    <Grid.Row>
                                            <Grid.Column width={10}>
                                                <Button color='green' onClick={() => {ManufacturerStore.openSelectedItem(0)}}>Új gyártó hozzáadása</Button>
                                            </Grid.Column>
                                        </Grid.Row>                    
                                        <Grid.Row centered>
                                            <Grid.Column width={16}>                                               
                                            <div id="grid" className="ag-theme-alpine" style={{width: '620px', height: '519px'}}>
                                                <AgGridReact											
                                                    rowData={toJS(ManufacturerStore.manufacturerItems)}											
                                                    columnDefs={ManufacturerStore.columnDef}
                                                    localeText={AgGridText}
                                                    pagination={true}
                                                    paginationPageSize={10}
                                                    frameworkComponents={{ btnCellRendererOpenItem: OpenItem,  btnDeleteCellRenderer: DeleteButton }}
                                                    gridOptions={{
                                                        paginationNumberFormatter: (params:any) => {
                                                        return  params.value.toLocaleString() ;
                                                      },
                                                    }}>	                                                    																			
                                                </AgGridReact>
                                            </div>                                              
                                            </Grid.Column>                                        
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>                                
							</Grid.Row>
						</Grid>
					</div>
            </Provider>
        </div>
    }
}

export default withNavigation(inject('RootStore')(observer(ManufacturerPage)));